//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";

export default {
    components: {
        AQModal,
        AQInput,
        AQCard
    },
    props: {
        name: { type: String, default: "" }
    },
    data() {
        return {
            extendParent: false,
            blockName: this.name || "",
            showModal: true,
            hasClose: true,
            headerActions: [
                {
                    label: this.$t("diagrams.components.conditionalBlock.deleteBlock")
                }
            ],
            blockNameError: false
        };
    },
    methods: {
        actionsDlg(event) {
            if (event === "primary") {
                if (!this.blockName.trim()) {
                    this.blockNameError = true;
                    return;
                }
                this.blockNameError = false;

                this.$emit("saveConditions", { name: this.blockName });
                this.$root.$emit("showCheckedSaveBtn", false);
            } else if (event === this.$t("diagrams.components.conditionalBlock.deleteBlock")) {
                this.$emit("deleteBlock");
            } else if (event === "close") {
                this.$emit("input", false);
            }
        }
    }
};
